// courses/course_C01.ts

export const course_C01 = `
  <div style="margin-bottom: 25px;">
    <h4 style="color: #0369a1; border-bottom: 2px solid #e2e8f0; padding-bottom: 8px; margin-bottom: 12px;">1. 한국 엔터테인먼트 매니지먼트의 발자취</h4>
    <p style="margin-bottom: 10px;">매니저라는 직업은 한국 대중문화의 성장과 궤를 같이하며 진화해 왔습니다.</p>
    <ul style="padding-left: 20px;">
      <li style="margin-bottom: 8px;"><strong>1960~80년대 (태동기):</strong> '가방 모찌' 혹은 '수행 비서'로 불리던 시절입니다. 주로 아티스트의 개인적인 일정 관리와 운전, 잔심부름을 담당하는 개인 조력자의 성격이 강했습니다.</li>
      <li style="margin-bottom: 8px;"><strong>1990년대 (성장기):</strong> 기획사 중심의 시스템이 도입되면서 '로드 매니저', '치프 매니저' 등의 직계가 생겨났습니다. 단순 수행을 넘어 홍보와 캐스팅 비즈니스가 전문화되기 시작한 시기입니다.</li>
      <li><strong>2000년대~현재 (전성기):</strong> K-POP과 K-콘텐츠가 세계로 뻗어나가며 매니지먼트는 기업화, 대형화되었습니다. 이제 매니저는 아티스트의 브랜딩을 책임지는 <strong style="color: #0284c7;">'콘텐츠 비즈니스 전문가'</strong>로 위상이 높아졌습니다.</li>
    </ul>
  </div>

  <div style="margin-bottom: 25px;">
    <h4 style="color: #0369a1; border-bottom: 2px solid #e2e8f0; padding-bottom: 8px; margin-bottom: 12px;">2. 현대 엔터테인먼트에서 매니저의 존재 이유</h4>
    <p style="margin-bottom: 10px;">단순히 운전을 하거나 곁을 지키는 수준을 넘어, 매니저는 산업의 핵심 엔진 역할을 수행합니다.</p>
    <ul style="padding-left: 20px;">
      <li style="margin-bottom: 8px;"><strong>비즈니스의 연결고리:</strong> 아티스트와 방송사, 제작사, 광고주 사이에서 모든 의사결정을 조율하는 실질적인 창구입니다.</li>
      <li style="margin-bottom: 8px;"><strong>리스크 관리자:</strong> 아티스트의 건강, 멘탈, 평판을 보호하는 최전방 방어선입니다. 현장에서의 작은 판단 착오가 기업의 존립을 흔들 수도 있습니다.</li>
      <li><strong>성장의 파트너:</strong> 아티스트의 재능을 발견하고, 어떤 작품과 활동이 필요한지 함께 고민하며 성공을 만들어가는 전략적 파트너입니다.</li>
    </ul>
  </div>

  <div style="margin-bottom: 25px;">
    <h4 style="color: #0369a1; border-bottom: 2px solid #e2e8f0; padding-bottom: 8px; margin-bottom: 12px;">3. 현재 매니저 교육의 현실과 우리의 필요성</h4>
    <ul style="padding-left: 20px;">
      <li style="margin-bottom: 12px;"><strong>법정 의무 교육 (문체부/콘진원 주관):</strong><br/>현재 '대중문화예술산업발전법'에 따라 기획업 종사자는 매년 법정 의무 교육을 이수해야 합니다. 주로 법령 준수, 성희롱 예방, 직업 윤리 등 '법률 및 제도적 소양'에 집중되어 있어 현장에서 필요한 구체적인 실무 스킬을 배우기에는 한계가 있습니다.</li>
      <li style="margin-bottom: 12px;"><strong>대학교 전공 교육:</strong><br/>'연예매니지먼트과' 등이 운영 중이지만, 이론 수업 비중이 높고 2~4년이라는 긴 시간이 소요된다는 특징이 있습니다.</li>
      <li><strong>실무 중심 교육의 부재:</strong><br/>여전히 주된 방식인 '도제식 교육'은 체계적인 매뉴얼 없이 선배의 습관을 답습하여 비효율이 고착되기도 합니다. 입문자가 '현장 매너', '아티스트 케어 요령' 같은 기초 실무를 집중적으로 배울 창구가 매우 부족합니다.</li>
    </ul>
  </div>

  <div style="margin-bottom: 25px;">
    <h4 style="color: #0369a1; border-bottom: 2px solid #e2e8f0; padding-bottom: 8px; margin-bottom: 12px;">4. 왜 'K-Ent Master Class' 기초 교육이 필요한가?</h4>
    <p style="margin-bottom: 10px;">우리는 기존 교육의 공백을 메우고, 현장에 즉시 투입 가능한 인재를 양성하기 위해 존재합니다.</p>
    <ul style="padding-left: 20px;">
      <li style="margin-bottom: 8px;"><strong>현장 적응력 극대화:</strong> "가서 눈치껏 해라"가 아닌, 구체적인 매뉴얼을 미리 학습하여 투입 즉시 제 역할을 하게 합니다.</li>
      <li style="margin-bottom: 8px;"><strong>전문직으로서의 자부심:</strong> 단순 노동이 아닌 전문 서비스직으로서의 기본 소양을 갖춥니다.</li>
      <li><strong>사고 예방 및 위기 대응:</strong> 수많은 돌발 상황에 대한 기초 대응법을 익혀 큰 사고를 방지합니다.</li>
    </ul>
  </div>

  <div style="background-color: #f0f9ff; padding: 20px; border-radius: 12px; border-left: 5px solid #0284c7; margin-top: 30px;">
    <strong style="color: #0369a1; font-size: 1.1rem; display: block; margin-bottom: 10px;">💡 교육생을 위한 다짐</strong>
    <p style="margin: 0; color: #334155; font-style: italic; line-height: 1.6;">
      "전문 교육을 받은 매니저는 아티스트의 시간을 아껴주고, 아티스트의 가치를 높입니다. 여러분은 오늘 그 첫발을 내디뎠습니다."
    </p>
  </div>
`;
